import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Mr2, UnderlineDecoration, Mr1 } from 'wrappers';
import { SecondaryTextSm, Empty } from 'atoms';
import { CloudSvg } from 'components/icons';

const template = styled.label`
  ${({ isHovered }) => css`
    height: ${isHovered ? '60px' : '43px'};
    min-width: 250px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border: ${isHovered ? `1px solid ${window?.settings?.primary_color ?? '#1DBD6B'}` : '1px dashed #D2D2D2'};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
    }
  `}
`;

export default Molecule({
  template,
  type: 'dropFiles',
  atoms: [
    {
      component: wrap(Empty, Mr2),
      name: 'Icon',
      displayValue: ({ }) => CloudSvg({})
    },
    {
      component: wrap(wrap(SecondaryTextSm, Mr1), UnderlineDecoration),
      name: 'UploadButton',
      displayValue: ({ }) => 'Upload files ',
    },
    {
      component: SecondaryTextSm,
      name: 'Second Text',
      displayValue: ({ }) => 'or Drag & Drop'
    }
  ]
})